import SongSettings from '~/routes/sing-a-song/song-selection/components/song-settings/song-settings';

export default SongSettings;
